import React, { Component } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { LoginPage } from './components/account/LoginPage.js';
import { constants, formModes, urls, listTypes, UserContext, backgroundTypes, hubEventTypes, customEventTypes, notificationTypes, transferRequestPositions } from './constants.js'
import MainContent from './components/MainContent.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/scss/app.scss';
import LastNewsWidget from './components/widgets/LastNewsWidget.js';
import DocumentList from './components/listsOfAlfresco/DocumentList.js';
import Document from './components/documents/Document.js';
import { logout } from './components/helpers/HelperFunctions.js';
import ServiceNotAvailablePage from './components/pages/ServiceNotAvailablePage.js';
import LastItemsWidget from './components/widgets/LastItemsWidget.js';
import Profile from './components/profile/Profile.js';
import CalendarPage from './components/pages/CalendarPage.js';
import SchedulePage from './components/pages/SchedulePage.js';
import { eventDispatcher } from './eventDispatcher.js';
import SuccessfullySignPage from './components/pages/SuccessfullySignPage.js';
import { BackgroundContainer } from './components/account/BackgroundContaner.js';
import NotificationMessanger from './components/forms/NotificationMessanger.js';
import NewWidgetsList from './components/widgets/NewWidgetsList.js';
import { v4 } from 'uuid';
import i18next from "./i18n.js";

export default class App extends Component {
    constructor(props) {
        super(props);
        let wasCallLogout = false;
        let error401 = false;

        this.state = { userData: JSON.parse(localStorage.getItem('user')) };
        this.onProfileUpdated = this.onProfileUpdated.bind(this);

        if (this.state.userData) {
            eventDispatcher.init(this.state.userData.token);
        }

        this.onProfileUpdatedId = eventDispatcher.subscrubeToEvent(hubEventTypes.profileUpdated, this.onProfileUpdated);

        window.fetch = new Proxy(window.fetch, {
            apply(fetch, that, args) {
                if ((!error401 || args[0] === '/api/Account/LogOut') && !wasCallLogout) {
                    if (args[0] === '/api/Account/LogOut') {
                        wasCallLogout = true;
                    }
                    const result = fetch.apply(that, args);
                    result.then(async (response) => {
                        if (response.status === 500) {
                            window.location.replace(urls.errror500Page);
                        }
                        if (response.status === 401) {
                            error401 === true;
                            logout();
                        }
                    })
                    return result
                }
            }
        });
    }

    componentWillUnmount() {
        eventDispatcher.unsubscrubeFromEvent(this.onProfileUpdatedId);
    }

    onProfileUpdated() {
        fetch(`/api/account/GetCurrentUser`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    console.error('GetCurrentUser error with status: ' + response.status);
                }
            })
            .then((data) => {
                if (data) {
                    const storageData = JSON.parse(localStorage.getItem('user'));
                    storageData.email = data.properties['cm:email'];
                    storageData.avatarId = data.associations?.avatar?.length > 0 ? data.associations.avatar[0].split('/').pop() : null;
                    storageData.childUnder3Years = data.properties['sxu:childUnder3Years'];
                    storageData.conscript = data.properties['sxu:conscript'];
                    storageData.iBan = data.properties['sxu:IBAN'];
                    let carInfo = null;
                    if (data.properties['carInformationForm']?.length > 0) {
                        const carProps = data.properties['carInformationForm'][0].properties;
                        carInfo = {
                            brand: carProps['sxu:carBrand'],
                            color: carProps['sxu:carColor'],
                            engineType: carProps['sxu:engineType'],
                            engineVolume: carProps['sxu:engineVolume'],
                            number: carProps['sxu:carNumber'],
                            releaseYear: carProps['sxu:carReleaseYear'],
                            fuelType: carProps['sxu:fuelType']
                        };
                    }
                    storageData.userCarInfo = carInfo;

                    localStorage.setItem('user', JSON.stringify(storageData));

                    this.setState({ userData: storageData });

                    eventDispatcher.invokeEvent(customEventTypes.onShowMessage, {
                        id: v4(),
                        title: i18next.t('notifications.profileUpdatedTitle'),
                        message: i18next.t('notifications.profileUpdatedMessage'),
                        type: notificationTypes.stateChanged
                    });
                }
            });
    }

    render() {
        return (
            <div className="root-block">
                <div id='modalDialog'></div>
                <div id="loadingDialog"></div>
                <div id={constants.placeholderDialogId}></div>
                <NotificationMessanger />
                <UserContext.Provider value={this.state.userData}>
                    <BrowserRouter>
                        <Routes>
                            <Route path={urls.loginPage} element={<LoginPage />} />
                            <Route path={urls.errror500Page} element={<ServiceNotAvailablePage />} />
                            <Route path={urls.successfullySignPage} element={<SuccessfullySignPage />} />
                            <Route exact path='/' element={<Home showBusinessTrip={this.state.userData?.canCreateBusinessTrip} showTransferRequest={transferRequestPositions.includes(this.state.userData?.position)} />} />
                            <Route exact path={urls.tasksPage} element={<Tasks />} />
                            <Route exact path={urls.documentsPage} element={<Documents />} />
                            <Route exact path={urls.calendarPage} element={<CalendarPage />} />
                            <Route exact path={urls.schedulePage} element={<SchedulePage />} />
                            <Route exact path={urls.profilePage} element={<Profile />} />
                            <Route exact path={`${urls.documentsPage}/:id`} element={<DocumentPage formMode={formModes.read} listType={listTypes.Documents} />} />
                            <Route exact path={`${urls.tasksPage}/:id`} element={<DocumentPage formMode={formModes.read} listType={listTypes.Tasks} />} />
                            <Route exact path={urls.newVacationPage} element={<DocumentPage formMode={formModes.create} listType={listTypes.Documents} />} />
                            <Route exact path={urls.newCertificationPage} element={<DocumentPage formMode={formModes.create} listType={listTypes.Certifications} />} />
                            <Route exact path={urls.newBusinessTripPage} element={<DocumentPage formMode={formModes.create} listType={listTypes.BusinessTrips} hideHeaderForMobile={true} />} />
                            <Route exact path={urls.newDetailsPage} element={<DocumentPage formMode={formModes.create} listType={listTypes.details} />} />
                            <Route exact path={urls.newTransferRequestPage} element={<DocumentPage formMode={formModes.create} listType={listTypes.TransferRequests} />} />
                        </Routes>
                    </BrowserRouter>
                </UserContext.Provider>
            </div>
        )
    }
}
export function Home(props) {
    return (
        <BackgroundContainer type={backgroundTypes.main} >
            <MainContent key="main-content">
                <LastNewsWidget />
                <NewWidgetsList showTransferRequest={props.showTransferRequest} showBusinessTrip={props.showBusinessTrip} />
                <LastItemsWidget type={listTypes.Tasks} />
                <LastItemsWidget type={listTypes.Documents} />
            </MainContent>
        </BackgroundContainer>
    );
}
export function Tasks() {
    return (
        <BackgroundContainer type={backgroundTypes.general} >
            <MainContent key="main-content">
                <DocumentList type={listTypes.Tasks} />
            </MainContent>
        </BackgroundContainer>
    );
}
export function Documents() {
    return (
        <BackgroundContainer type={backgroundTypes.general} >
            <MainContent key="main-content">
                <DocumentList type={listTypes.Documents} />
            </MainContent>
        </BackgroundContainer>
    );
}
export function DocumentPage(props) {
    return (
        <BackgroundContainer type={backgroundTypes.general} >
            <MainContent key="main-content" hideHeaderForMobile={props.hideHeaderForMobile} >
                <Document formMode={props.formMode} listType={props.listType} />
            </MainContent>
        </BackgroundContainer>
    );
}